import Layout from '@/components/Layout/Vanilla';
import Button from '@/components/Button';
import Hero from '@/components/Hero';
import IndustryList from '@/components/IndustryList';
import ContentBlock from '@/components/ContentBlock';
import TestimonialCard from '@/components/TestimonialCard';
import USPGrid from '@/components/USPGrid';
import { SignupBreakpoint } from '@/components/Breakpoint';
import { DefaultLogoReel } from '@/components/LogoReel';
import Section from '@/components/Section';

export default function Solution({
  page: { title, caseStudies, usps, contentBlocks, ...page },
  uspTitle,
  uspDescription,
  children,
}) {
  return (
    <Layout seo={page}>
      <Section>
        <Hero
          {...page}
          coverImage={{ ...page.coverImage, width: 1056, height: 950 }}
          title={`GraphCMS for ${title}`}
          alignment="left"
        >
          <Button
            href="/contact"
            appearance="outline"
            colour="pink"
            size="large"
          >
            Get an Enterprise Demo &#8594;
          </Button>
        </Hero>
      </Section>

      <DefaultLogoReel />

      <Section>
        {children}
        <IndustryList entries={contentBlocks} Component={ContentBlock} />
      </Section>

      <SignupBreakpoint />

      <Section colour="light">
        <IndustryList entries={caseStudies} Component={TestimonialCard} />
      </Section>

      <Section>
        <USPGrid title={uspTitle} description={uspDescription} items={usps} />
      </Section>
    </Layout>
  );
}
